var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModalCrear",
        {
          attrs: { titulo: "Crear Recepción de Información" },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c("NavegacionModalCrud", {
            attrs: { pasos: _vm.pasos, "estado-id": _vm.estadoId },
            on: { guardar: _vm.handleGuardarClick },
            model: {
              value: _vm.pasoActivoIndex,
              callback: function($$v) {
                _vm.pasoActivoIndex = $$v
              },
              expression: "pasoActivoIndex"
            }
          })
        ],
        1
      ),
      _c(
        "v-stepper",
        {
          model: {
            value: _vm.pasoActivoIndex,
            callback: function($$v) {
              _vm.pasoActivoIndex = $$v
            },
            expression: "pasoActivoIndex"
          }
        },
        [
          _c("CrudStepperHeader", {
            attrs: {
              pasos: _vm.pasos,
              "paso-activo-index": _vm.pasoActivoIndex
            }
          }),
          _c(
            "CrudStepperItems",
            [
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.informacionGeneral } },
                [
                  _c("RecepcionActividadForm", {
                    attrs: { "test-id": "CrearRecepcionActividadModal" },
                    on: { change: _vm.handleFormChange }
                  })
                ],
                1
              ),
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.asociarVehiculos } },
                [
                  _c("AsociarFlotaEtiquetaVehiculoIndividual", {
                    attrs: {
                      "col-def-vehiculo": _vm.vehiculoColDefs,
                      filtroGps: true
                    },
                    on: { change: _vm.handleAsociacionesChange }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogConfirmacionGuardar,
          titulo: _vm.$t("mensajes.crud.crear.titulo", {
            entidad: "Recepción de Información"
          }),
          mensaje: _vm.mensajeConfirmacionInactivo,
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: { modalConfirmationEmit: _vm.handleConfirmacionGuardar }
      }),
      _c("MensajeValidacion", {
        attrs: {
          showDialog: _vm.showValidacion,
          titulo: _vm.tituloValidacion,
          mensaje: _vm.mensajeValidacion
        },
        on: {
          modalConfirmationEmit: function($event) {
            _vm.showValidacion = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }